
export const portfolio = [
  {
    title: "Flood Detection",
    description: "Pendeteksi banjir yang terintegrasi IoT melalui Firebase",
    category: "Mobile App",
    imageUrl: "/images/portfolio/flood-detection.webp",  
  },
  {
    title: "Royale Fragrance",
    description: "Visualisasi aroma parfum maskulin melalui pendekatan desain yang elegan dan kuat",
    category: "Product Design",
    imageUrl: "/images/portfolio/royale-fragrance.webp",  
  },
  {
    title: "LA Shirt",
    description: "Desain kaos minimalis, menonjolkan elemen visual tanpa menghilangkan identitas karakter dan nilai brand.",
    category: "Shirt Design",
    imageUrl: "/images/portfolio/la-shirt.webp",  
  },
  {
    title: "Lawang Sewu",
    description: "Pengembangan game Roblox Lawang Sewu yang mengadaptasi elemen arsitektur dan suasana ikoniknya ke dalam pengalaman interaktif yang imersif.",
    category: "Roblox Game",
    imageUrl: "/images/portfolio/lawang-sewu.webp",  
  },
  {
    title: "Koni Mustika Cup",
    description: "Desain dirancang mengikuti tren desain terkini, komposisi dinamis tanpa menghilangkan kejelasan informasi acara.",
    category: "Banner Event",
    imageUrl: "/images/portfolio/koni-mustika-cup.webp",  
  },
  {
    title: "Gaskeep Competition",
    description: "Kompetisi pembuatan desain arsitektur yang divusualisasikan dalam bentuk 3D.",
    category: "Visualisation",
    imageUrl: "/images/portfolio/gaskeep-competition.webp",  
  },
];
